import { fetchMeetInfo } from './feetchMeetInfo';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { MeetInfo } from '../types/Video';

export const useMeetInfo = () => {
  const { meetId } = useParams<{ meetId: string }>();

  const [meetInfo, setMeetInfo] = useState<MeetInfo>({} as MeetInfo);
  const [fetchMeetInfoLoading, setFetchMeetInfoLoading] = useState<boolean>(true);
  const [fetchMeetInfoError, setFetchMeetInfoError] = useState<string>('');

  useEffect(() => {
    (async () => {
      if (meetId) {
        try {
          setMeetInfo(await fetchMeetInfo(meetId));
        } catch (err) {
          setFetchMeetInfoError(err instanceof Error ? err.message : 'Nieznany błąd');
        } finally {
          setFetchMeetInfoLoading(false);
        }
      }
    })();
  }, [meetId]);

  return { meetInfo, fetchMeetInfoLoading, fetchMeetInfoError };
};
